"use strict";

import Backbone from 'backbone';
import _ from 'underscore';


export default class MapOverlayView extends Backbone.View {
  get mapEvents() {
    return {};
  }

  get overlay() {
    throw new Error('Overlay constructor not supplied');
  }

  get overlayOptions() {
    return {
      map: this.map
    };
  }

  initialize(options) {
    // Ensure map and API loaded
    if (!google || !google.maps) {
      throw new Error("Google maps API is not loaded.");
    }
    if (!options.map && !this.map) {
      throw new Error("A map must be specified.");
    }
    this.map = options.map;
    this.gOverlay = new this.overlay(this.overlayOptions);
  }

  bindMapEvents() {
    var mapEvents = this.mapEvents;

    for (var key in mapEvents) {
      var method = mapEvents[key];

      if (!_.isFunction(method)) {
        method = this[mapEvents[key]];
      }
      if (!method) {
        throw new Error('Method "' + mapEvents[key] + '" does not exist');
      }
      method = _.bind(method, this);
      google.maps.event.addListener(this.gOverlay, key, method);
    }
  }

  render() {
    this.bindMapEvents();
    return this;
  }

  remove(args) {
    google.maps.event.clearInstanceListeners(this.gOverlay);
    this.gOverlay.setMap(null);
    delete this.gOverlay;
    super.remove(args);
    return this;
  }
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/views/geo/MapOverlayView.js
 **/